import { useState } from 'react';
import { CerebroBreadcrumb, CerebroPageContainer } from '../../shared/components';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Skeleton, Tab } from '@mui/material';
import { useDirectConnectLenderInvitesQuery } from '../../shared/hooks';
import { useParams } from 'react-router-dom';
import { LenderInvitePageActionButton } from './LenderInvitePageActionButton';
import { LenderInviteList } from './LenderInviteList';
import { SearchForLenderInviteDrawer } from './SearchForLenderInviteDrawer';
import { InvitePreview } from './InvitePreview';
import { InviteSummaryDrawer } from './InviteSummaryDrawer';

export const LenderInvitesPage: React.FC = () => {
	const { guid } = useParams<'guid'>();
	const [tab, setTab] = useState('pending');
	const [searchDrawer, setSearchDrawer] = useState<boolean>(false);
	const [editingSummary, setEditingSummary] = useState<boolean>(false);
	const [emailTeaserPreview, setEmailTeaserPreview] = useState<boolean>(false);

	const invitesQuery = useDirectConnectLenderInvitesQuery(guid);

	const handleTabChange = (event: any, newValue: string) => {
		setTab(newValue);
	};

	return (
		<CerebroPageContainer maxWidth={'100%'}>
			<CerebroBreadcrumb>Lender Invites</CerebroBreadcrumb>

			{invitesQuery.isSuccess && (
				<Box sx={{ marginBottom: 3 }}>
					<LenderInvitePageActionButton
						onSearchLender={() => setSearchDrawer(true)}
						onTeaserPreview={setEmailTeaserPreview}
						onEditSummary={setEditingSummary}
					/>

					<InvitePreview
						open={emailTeaserPreview}
						preview={invitesQuery.data.teaserPreview}
						onClose={() => setEmailTeaserPreview(false)}
					/>

					<InviteSummaryDrawer
						open={editingSummary}
						dataRoom={invitesQuery.data.dataRoom}
						onClose={() => setEditingSummary(false)}
					/>

					<SearchForLenderInviteDrawer
						dealGuid={invitesQuery.data.dataRoom.dealGuid}
						open={searchDrawer}
						onClose={() => setSearchDrawer(false)}
					/>
				</Box>
			)}

			<TabContext value={tab}>
				<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
					<TabList onChange={handleTabChange}>
						<Tab label="Pending Response" value="pending" />
						<Tab label="Accepted" value="accepted" />
						<Tab label="Declined" value="declined" />
					</TabList>
				</Box>

				{invitesQuery.isLoading && (
					<>
						<Skeleton height={200} />
						<Skeleton height={200} />
						<Skeleton height={200} />
					</>
				)}

				{invitesQuery.isSuccess && (
					<>
						<TabPanel value="pending">
							<LenderInviteList
								invites={invitesQuery.data.invites
									.filter(w => w.inviteStatus == 'PendingResponse')
									?.sort((a, b) => a.bankName.localeCompare(b.bankName))}
								isAcceptedTab={false}
							/>
						</TabPanel>
						<TabPanel value="accepted">
							<LenderInviteList
								invites={invitesQuery.data.invites
									.filter(w => w.inviteStatus == 'Interested')
									?.sort((a, b) => a.bankName.localeCompare(b.bankName))}
								isAcceptedTab={true}
							/>
						</TabPanel>
						<TabPanel value="declined">
							<LenderInviteList
								invites={invitesQuery.data.invites
									.filter(w => w.inviteStatus == 'NotInterested')
									?.sort((a, b) => a.bankName.localeCompare(b.bankName))}
								isAcceptedTab={false}
							/>
						</TabPanel>
					</>
				)}
			</TabContext>
		</CerebroPageContainer>
	);
};
